import {
  RECONSIDERATION_PENDING_BY_VOLUME_SUCCESS,
  RECONSIDERATION_PENDING_BY_VOLUME_LOADING,
  RECONSIDERATION_AVERAGE_TURNAROUND_TIME_SUCCESS,
  RECONSIDERATION_AVERAGE_TURNAROUND_TIME_LOADING,
  RECONSIDERATION_OUTCOME_VOLUME_DATA_REQUEST,
  RECONSIDERATION_OUTCOME_VOLUME_DATA_SUCCESS,
  RECONSIDERATION_OUTCOME_VOLUME_DATA_FAILURE,
  RECONSIDERATION_OUTCOME_SUBMISSION_DATA_REQUEST,
  RECONSIDERATION_OUTCOME_SUBMISSION_DATA_FAILURE,
  RECONSIDERATION_OUTCOME_SUBMISSION_DATA_SUCCESS,
  RECONSIDERATION_DETAILS_REQUEST,
  RECONSIDERATION_DETAILS_FAILURE,
  RECONSIDERATION_DETAILS_SUCCESS,
} from '../../../actions/actionTypes';

type ReconsiderationRecord = Record<string, unknown>;
type ReconsiderationPayload = ReconsiderationRecord | unknown[] | boolean | string | null;

interface ReconsiderationState {
  reConsiderationPendingByVolumeData: ReconsiderationRecord;
  reConsiderationAverageTurnaroundTimeData: ReconsiderationRecord;
  isLoadingByVolume: boolean;
  isLoadingAverageTurnaroundTime: boolean;
  isLoading: boolean;
  pendingRequestCount: number;
  error: string | null;
  outcomeReasons: unknown[];
  submissionReasons: unknown[];
  reconsiderationDetails: ReconsiderationRecord;
}

const initialState: ReconsiderationState = {
  reConsiderationPendingByVolumeData: {},
  reConsiderationAverageTurnaroundTimeData: {},
  isLoadingByVolume: false,
  isLoadingAverageTurnaroundTime: false,
  isLoading: false,
  pendingRequestCount: 0,
  error: null,
  outcomeReasons: [],
  submissionReasons: [],
  reconsiderationDetails: {},
};

const ReconsiderationReducer = (
  state = initialState,
  action: { type: string; payload?: ReconsiderationPayload }
): ReconsiderationState => {
  switch (action.type) {
    case RECONSIDERATION_PENDING_BY_VOLUME_LOADING:
      return {
        ...state,
        isLoadingByVolume: action.payload === true,
      };

    case RECONSIDERATION_PENDING_BY_VOLUME_SUCCESS:
      return {
        ...state,
        reConsiderationPendingByVolumeData: action.payload as ReconsiderationRecord,
      };

    case RECONSIDERATION_AVERAGE_TURNAROUND_TIME_SUCCESS:
      return {
        ...state,
        reConsiderationAverageTurnaroundTimeData: action.payload as ReconsiderationRecord,
      };

    case RECONSIDERATION_AVERAGE_TURNAROUND_TIME_LOADING:
      return {
        ...state,
        isLoadingAverageTurnaroundTime: action.payload === true,
      };
    case RECONSIDERATION_OUTCOME_VOLUME_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RECONSIDERATION_OUTCOME_VOLUME_DATA_SUCCESS:
      return {
        ...state,
        outcomeReasons: action.payload as unknown[],
        isLoading: state.pendingRequestCount > 1,
        pendingRequestCount: Math.max(0, state.pendingRequestCount - 1),
      };
    case RECONSIDERATION_OUTCOME_VOLUME_DATA_FAILURE:
      return {
        ...state,
        error: typeof action.payload === 'string' ? action.payload : null,
        isLoading: state.pendingRequestCount > 1,
        pendingRequestCount: Math.max(0, state.pendingRequestCount - 1),
      };

    case RECONSIDERATION_OUTCOME_SUBMISSION_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RECONSIDERATION_OUTCOME_SUBMISSION_DATA_SUCCESS:
      return {
        ...state,
        submissionReasons: action.payload as unknown[],
        isLoading: state.pendingRequestCount > 1,
        pendingRequestCount: Math.max(0, state.pendingRequestCount - 1),
      };
    case RECONSIDERATION_OUTCOME_SUBMISSION_DATA_FAILURE:
      return {
        ...state,
        error: typeof action.payload === 'string' ? action.payload : null,
        isLoading: state.pendingRequestCount > 1,
        pendingRequestCount: Math.max(0, state.pendingRequestCount - 1),
      };
    case RECONSIDERATION_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        pendingRequestCount: 3,
      };
    case RECONSIDERATION_DETAILS_SUCCESS:
      return {
        ...state,
        reconsiderationDetails: action.payload as ReconsiderationRecord,
        isLoading: state.pendingRequestCount > 1,
        pendingRequestCount: Math.max(0, state.pendingRequestCount - 1),
      };
    case RECONSIDERATION_DETAILS_FAILURE:
      return {
        ...state,
        error: typeof action.payload === 'string' ? action.payload : null,
        isLoading: state.pendingRequestCount > 1,
        pendingRequestCount: Math.max(0, state.pendingRequestCount - 1),
      };

    default:
      return state;
  }
};

export default ReconsiderationReducer;
